import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
import { SubmitgyanService } from './../../core/services/submit-gyan/submitgyan.service';
import { Component, ViewChild, ChangeDetectorRef, Output, Input, EventEmitter, TemplateRef, ElementRef } from '@angular/core';
import { faAngleUp, faArrowLeft, faAngleRight, faAngleDown, faL } from '@fortawesome/free-solid-svg-icons';
import { Options } from '@angular-slider/ngx-slider';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { LocalStorageService } from './../../core/services/local-storage/local-storage.service';
import { Subscription, Subject, fromEvent } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GyanOrganisationService } from './../../core/services/gyan-organisation/gyan-organisation.service';
import { BreadcrumbService } from './breadcrumb/breadcrumb.service';
import { Topic } from './topic.interface';
import { PreviousDataService } from 'src/app/core/services/previous-gyan/previous-data.service';
import { MoveBreadcrumbService } from './moveBreadcrumb/moveBreadcrumb.service';
import { debounceTime } from 'rxjs/operators';
import { SanitizeService } from 'src/app/shared/services/sanitize.service';
@Component({
    selector: 'app-gyan-organisation',
    templateUrl: './gyan-organisation.component.html',
    styleUrls: ['./gyan-organisation.component.scss'],
})
export class GyanOrganisationComponent {
    @Output() viewChanged = new EventEmitter<string>();
    @Input() recentSearchesList: any;
    @Input() isTopicLoading: boolean = true;
    isLoading = true;
    isMobile = window.innerWidth < 768 ? true : false;
    metaData: any;
    topicDetailsOffset = 0;
    findByNameOffset = 0;
    totalCount = 0;
    countofTopics = 0;
    countofPending = 0;
    findByNameValue = '';
    allowSearch = true;
    searchFrom = 'All Searches';
    gyanFamily = ['ADVANCED', 'TEMPLATE', 'SENTENCE'];
    //isGridView = JSON.parse(localStorage.getItem('isGridView')) || true;
    isGridView = true;
    selectedFilter = 'Filter';
    selectedSort = 'Sort';
    newFolderName: any = null;
    isNewFolderActive = false;
    isNewFolderHovered = false;
    isMoveItemActive = false;
    isMoveItemHovered = false;
    currentTopicPath: Array<any> = [];
    isBreadCrumbKey = false;
    breadCrumbKey = '';
    folderId: null | undefined;
    sortType = 'date';
    sortBy = 'desc';
    private searchSubject: Subject<string> = new Subject();
    createFolderError: string | undefined;
    showCreateFolderError = true;
    CreateFolderPermission: boolean | undefined;
    selectedItems = [];
    callTopicDetails = true;
    findText = '';
    infiniteScrollDistance: number | undefined;
    infiniteScrollThrottle: number | undefined;
    showMoveLoader = false;
    currentFolders = [];
    errorFetchingFolder: string | undefined;
    currentPath: Array<any> = [];
    showBreadcrumb = true;
    parentFolderId = null;
    selectedFolderId = null;
    moveError = '';
    multiSelected: Array<any> = [];
    isHoverEffectEnabled = false;
    selecteditem: any = null;
    topicName = '';

    private scrollSubject = new Subject<void>();
    private findByNameInputSubject = new Subject<string>();
    private modalRef: NgbModalRef | undefined;
    @ViewChild('confirmChangesModal') confirmChangesModal!: TemplateRef<any>;

    constructor(
        private authservice: AuthService,
        private commonservice: CommonServiceService,
        private gyanOrganisationService: GyanOrganisationService,
        private localStorageService: LocalStorageService,
        private cd: ChangeDetectorRef,
        private modalService: NgbModal,
        private fb: FormBuilder,
        private breadcrumbService: BreadcrumbService,
        private previousDataService: PreviousDataService,
        private submitgyanservice: SubmitgyanService,
        private moveBreadcrumbService: MoveBreadcrumbService,
        private elRef: ElementRef,
        private toastrService: ToastrService,
        private sanitizeService: SanitizeService,
    ) {
        this.isTopicLoading = true;

        this.scrollSubject.pipe(debounceTime(800)).subscribe(() => {
            const data = this.findText;
            this.callScrollService(data);
        });

        this.findByNameInputSubject.pipe(debounceTime(800)).subscribe((value) => {
            this.callFindByNameService(value);
        });
    }
    ngAfterViewInit() {
        if (this.modalRef) {
            this.modalRef.close();
        }
    }
    ngOnInit() {
        this.getAccessPermission();
        this.breadcrumbService.currentBreadcrumbs.subscribe((breadcrumbs) => {
            this.currentTopicPath = breadcrumbs;
            if (breadcrumbs.length > 0) {
                const breadcrumb: any = breadcrumbs[breadcrumbs.length - 1];
                console.log('breadcrumb', breadcrumb);
                this.folderId = breadcrumb?.topicId;
            } else {
                this.folderId = null;
            }
        });

        this.previousDataService.callAllTopicDataEvent$.subscribe((data) => {
            console.log('GyanOrganisationComponent.callAllTopicDataEvent.data', data);
            //if (this.isMobile) {
            this.recentSearchesList = data;
            this.cd.detectChanges();
            //}
            //this.isTopicLoading = false;
        });

        this.previousDataService.callLoadingEvent$.subscribe((data) => {
            console.log('GyanOrganisationComponent.callLoadingEvent.data', data);
            this.isTopicLoading = data;
        });

        console.log('GyanOrganisationComponent.recentSearchesList.ngOnInit', this.recentSearchesList);

        //if data is empty
        if (this.recentSearchesList.length === 0) this.previousDataService.emitCallAllTopicDetailsClickEvent();

        // //after clicking on yes
        if (localStorage.getItem('tempGyanName') !== null) {
            this.createGysnBtnClick();
            localStorage.removeItem('tempGyanName');
        }
    }

    getAccessPermission() {
        this.CreateFolderPermission = this.authservice.getAccessList('CreateFolder');
    }

    callScrollService(data: any) {
        // Call the service method after the debounce
        this.previousDataService.emitScrollEvent(data);
    }

    onScrollDown() {
        this.scrollSubject.next();
    }

    onViewChanged(view: string) {
        this.isGridView = view === 'grid';
        localStorage.setItem('isGridView', JSON.stringify(view === 'grid'));
        this.viewChanged.emit(view);
    }

    onFilterSelected(filter: string) {
        this.selectedFilter = filter;
    }

    onSortSelected(event: any) {
        this.sortType = event.sortType;
        this.sortBy = event.sortBy;
        console.log('onSortSelected.event', event);
        this.previousDataService.emitCallAllTopicWithParamClickEvent(event);
        //this.getMyTopicDetails();
    }

    showNewFolderModal(templateModal: TemplateRef<any>) {
        this.isNewFolderActive = true;
        //this.bsModalRef = this.modalService.show(templateModal, Object.assign({}, { class: 'modal-createFolder' }));
    }

    showMoveFolderModal() {
        this.isMoveItemActive = true;
        // if (this.childTemplateModal) {
        //     this.childPage.showMoveModal(this.childTemplateModal, {});
        // } else {
        //     console.error('Template reference not available');
        // }
    }

    closeMoveModal() {
        this.isMoveItemActive = false;
        if (this.modalRef) {
            this.modalRef.close();
        }
    }

    createNewFolder() {
        if (this.newFolderName.trim() == '') {
            return;
        }
        const reqBody = {
            folderName: this.newFolderName,
            parentFolderId: null,
        };
        if (this.folderId) {
            reqBody.parentFolderId = this.folderId;
        }
        console.log('createNewFolder.folderId', this.folderId);
        console.log('createNewFolder.reqBody', reqBody);
        this.gyanOrganisationService.createFolderByName(reqBody).subscribe(
            (res) => {
                this.closeCFModal();
                this.newFolderName = null;
                this.showCreateFolderError = false;
                console.log('createNewFolder.currentTopicPath', this.currentTopicPath);
                this.callTopicDetailsClick();
            },
            (err: { error: { message: string | undefined } }) => {
                this.showCreateFolderError = true;
                this.createFolderError = err.error.message;
                this.cd.detectChanges();
            },
        );
    }

    closeCFModal() {
        this.newFolderName = null;
        this.isNewFolderActive = false;
        this.showCreateFolderError = false;
        this.createFolderError = '';
        if (this.modalRef) {
            this.modalRef.close();
        }
    }

    allClicked() {
        this.clearBreadcrumbs();
        this.currentTopicPath = [];
        this.folderId = null;
        this.selectedItems = [];
        this.breadcrumbService.updateBreadcrumbs(this.currentTopicPath);
    }

    clearBreadcrumbs() {
        if (this.isBreadCrumbKey) {
            sessionStorage.removeItem(this.breadCrumbKey); // Delete the key from sessionStorage
        }
    }

    callFindByNameService(value: any) {
        // Call the service method after the debounce
        this.previousDataService.emitCallFindByNameClickEvent(value);
    }

    onSearchInput(value: string) {
        console.log('onSearchInput.value', value);

        const sanitizedValue = this.sanitizeService.sanitizeInput(value);

        // Only update and emit if the sanitized value differs
        if (value !== sanitizedValue) {
            value = sanitizedValue;
        }

        this.findText = value;
        this.findByNameInputSubject.next(value);
    }

    ngOnDestroy() {
        this.clearBreadcrumbs();
        this.currentTopicPath = [];
        this.breadcrumbService.updateBreadcrumbs(this.currentTopicPath);
        this.modalRef?.close();
    }

    selectedItemsFunction(value: Array<never>) {
        this.selectedItems = value;
    }

    onMoveMouseEnter() {
        this.isMoveItemHovered = true;
    }

    onMoveMouseLeave() {
        this.isMoveItemHovered = false;
    }

    onFolderMouseEnter() {
        console.log('onFolderMouseEnter');
        this.isNewFolderHovered = true;
    }

    onFolderMouseLeave() {
        this.isNewFolderHovered = false;
    }

    findByName(data: any) {
        console.log('findByName.data', data);
        this.previousDataService.emitCallFindByNameClickEvent(data);
    }

    showAllSearches() {
        this.searchFrom = 'All Searches';
        this.currentTopicPath = [];
        this.breadcrumbService.updateBreadcrumbs(this.currentTopicPath);
        console.log('showAllSearches.currentTopicPath', this.currentTopicPath);
        this.previousDataService.emitCallAllTopicDetailsClickEvent();
    }

    onTopicBreadcrumbClick(index: number) {
        console.log('onTopicBreadcrumbClick.currentTopicPath', this.currentTopicPath);
        const clickTopic: any = this.currentTopicPath[index];
        this.folderId = clickTopic.topicId;
        this.currentTopicPath = this.currentTopicPath.slice(0, index + 1);
        this.breadcrumbService.updateBreadcrumbs(this.currentTopicPath);
        this.selectedItems = [];
        this.clearBreadcrumbs();
        this.previousDataService.emitCallTopicDetailsClickEvent(clickTopic.topicId);
        //this.getMyTopicDetails();
    }

    showFolderPopup(content: any, popupSize: string): void {
        this.newFolderName = '';
        this.showCreateFolderError = false;
        this.createFolderError = '';
        this.modalRef = this.modalService.open(content, { size: popupSize, windowClass: 'custom-modal-class' });
    }

    moveItem(item: any) {
        console.log('moveItem.item', item);
        this.selecteditem = item;
    }

    showMovePopup(item: any, content: any, popupSize: string): void {
        this.fetchMoveFoldersList(null);
        if (item) {
            this.topicName = item.topicName;
            this.selecteditem = item;
        }
        this.modalRef = this.modalService.open(content, { size: popupSize, windowClass: 'custom-modal-class move-modal' });
        console.log('showMovePopup.multiSelected', this.multiSelected);
        console.log('showMovePopup.selecteditem', this.selecteditem);
    }

    createGysnBtnClick() {
        const storedData = localStorage.getItem('topicOutline');
        if (storedData) {
            const topicOutline = JSON.parse(storedData);
            console.log('topicOutline', topicOutline);
            if (topicOutline !== null) {
                if (topicOutline.name !== '') {
                    this.openConfirmChangesModal();
                } else {
                    console.log('createGysnBtnClick');
                    const data = {};
                    this.commonservice.setCallUseAsTemplate(data);
                    this.submitgyanservice.emitSubmitGyanClickEvent(true);
                }
            }
        } else {
            console.log('createGysnBtnClick');
            const data = {};
            this.commonservice.setCallUseAsTemplate(data);
            this.submitgyanservice.emitSubmitGyanClickEvent(true);
        }
    }

    onConfirmGyan() {
        if (this.modalRef) {
            this.modalRef.close(); // Closes the modal
        }
        console.log('createGysnBtnClick');
        this.commonservice.setConfirmGyan(true);
        this.commonservice.setTemplatetLoaded(true);
        this.commonservice.setCancelFlag(false);
        this.submitgyanservice.emitSubmitGyanClickEvent(true);

        //should be removed when save draft implemented
        // this.commonservice.setTemplateDataSubject({});
        // this.commonservice.setTemplateDataSubjectForSources({});
        // this.commonservice.setTemplateDataSubjectForTopicOutline({});
        // this.commonservice.setTemplateDataSubjectForConfig({});
    }

    cancelConfirmGyan() {
        if (this.modalRef) {
            this.modalRef.close(); // Closes the modal
        }
        this.commonservice.setCancelFlag(true);
        this.commonservice.setConfirmGyan(false);
        this.commonservice.setTemplatetLoaded(false);
        this.commonservice.setDraftLoaded(null);
        console.log('createGysnBtnClick');
        const data = {};
        this.commonservice.setCallUseAsTemplate(data);
        this.submitgyanservice.emitSubmitGyanClickEvent(true);
    }

    openConfirmChangesModal() {
        this.modalRef = this.modalService.open(this.confirmChangesModal, {
            centered: true,
            size: this.isMobile ? 'sm' : 'ms',
            windowClass: this.isMobile ? 'custom-modal-class-confrim-mb' : 'custom-modal-class-confrim',
        });
    }

    moveGyan() {
        console.log('moveFolder.multiSelected', this.multiSelected);
        console.log('moveFolder.selecteditem', this.selecteditem);
        this.showMoveLoader = true;
        if (this.selectedFolderId === this.folderId) {
            this.moveError = 'The Gyan/Folder already exists in this folder';
            this.showMoveLoader = false;
            return;
        }

        const topicIdArray = this.multiSelected.map((item) => item.topicId);
        if (this.multiSelected.length === 0 && this.selecteditem) {
            topicIdArray.push(this.selecteditem?.topicId);
        }
        console.log('moveFolder.topicIdArray', topicIdArray);
        if (topicIdArray.length > 0) {
            const reqBody = {
                //gyanId: this.selecteditem.topicId,
                gyanIds: topicIdArray,
                folderId: this.selectedFolderId,
                parentFolderId: this.folderId,
            };
            console.log('moveFolder.reqBody', reqBody);
            this.previousDataService.moveGyan(reqBody).subscribe(
                (response) => {
                    if (response) {
                        this.closeMoveModal();
                        this.multiSelected = [];
                        this.showMoveLoader = false;
                        this.clearMoveBreadcrumb();
                        this.toastrService.success(response.message);
                        this.previousDataService.emitMoveTopicClickEvent({
                            topicIdArray: topicIdArray,
                            sourceFolderId: this.folderId,
                            destinationFolderId: this.selectedFolderId,
                        });
                        this.callTopicDetailsClick();
                        this.selecteditem = null;
                        // this.selectedItemsEvent.emit(this.multiSelected);
                        // this.callGetMyTopicDetails.emit(this.folderId);
                    }
                },
                (error) => {
                    console.log(error);
                    this.showMoveLoader = false;
                    //this.selecteditem = null;
                    //this.toastrService.error(error.error.message);
                    this.moveError = error.error.message;
                    //this.moveError = 'There was error in moving the item';
                    //this.toastr.error('There was error in moveGyan the item');
                },
            );
        } else {
            this.moveError = 'There was No Gyan / Folder selected to move';
        }
    }

    clearMoveBreadcrumb() {
        this.currentPath = [];
        this.moveBreadcrumbService.updateBreadcrumbs(this.currentPath);
    }

    callTopicDetailsClick() {
        if (this.currentTopicPath.length > 0) {
            const topic = this.currentTopicPath[this.currentTopicPath.length - 1];
            console.log('createNewFolder.topic', topic);
            this.previousDataService.emitCallTopicDetailsClickEvent(topic.topicId);
        } else {
            //this.previousDataService.emitCallAllTopicDetailsClickEvent();
            if (this.folderId) {
                this.previousDataService.emitCallTopicDetailsClickEvent(this.folderId);
            } else {
                this.previousDataService.emitCallAllTopicDetailsClickEvent();
            }
        }
    }

    onFolderClick(folder: any) {
        this.fetchMoveFoldersList(folder.folderId);
        this.currentPath.push(folder);
        this.currentFolders = folder.children || [];
        this.moveBreadcrumbService.updateBreadcrumbs(this.currentPath);
        this.showBreadcrumb = false;
    }

    fetchMoveFoldersList(folderId: any) {
        this.moveError = '';
        this.errorFetchingFolder = '';
        this.showMoveLoader = true;
        this.selectedFolderId = folderId;
        this.previousDataService.fetchFoldersList(folderId).subscribe(
            (response: any) => {
                if (response) {
                    this.showMoveLoader = false;
                    const selectedIds = this.multiSelected.map((item: any) => {
                        return item.topicId;
                    });
                    if (this.multiSelected.length === 0 && this.selecteditem) {
                        selectedIds.push(this.selecteditem?.topicId);
                    }
                    // console.log('fetchMoveFoldersList.multiSelected', this.multiSelected);
                    // console.log('fetchMoveFoldersList.selectedIds', selectedIds);
                    //console.log('fetchMoveFoldersList.selectedIds', folders);
                    const folders = response.map((folder: any) => {
                        return {
                            ...folder,
                            isDisabled: selectedIds.includes(folder.folderId) ? true : false,
                        };
                    });
                    this.previousDataService.updateFolderList(folders);
                    console.log('fetchMoveFoldersList.folders', folders);
                    //this.currentFolders = folders;
                    //this.previousDataService.updateFolderList(response);
                    //this.changeDetection.detectChanges();
                }
            },
            (error: any) => {
                this.showMoveLoader = false;
                console.log(error);
                this.errorFetchingFolder = 'There was error in listing the folders';
            },
        );
    }

    onBreadcrumbClick(index: any) {
        const clickFolder = this.currentPath[index];
        const folderId = clickFolder.folderId;
        this.fetchMoveFoldersList(folderId);
        this.currentPath = this.currentPath.slice(0, index + 1);
        this.currentFolders = this.currentPath.length ? this.currentPath[index].children : [];
        this.moveBreadcrumbService.updateBreadcrumbs(this.currentPath);
    }

    onAllClick() {
        console.log('onAllClick.org');
        this.currentPath = [];
        this.currentFolders = [];
        this.moveBreadcrumbService.updateBreadcrumbs(this.currentPath);
        this.fetchMoveFoldersList(null);
    }

    selectItem(item: any) {
        console.log('parent.selectItem.item', item);
        const index = this.multiSelected.findIndex((selectedItem) => selectedItem.topicId === item.topicId);
        if (index > -1) {
            item.isSelected = false;
            // If the item is already present, remove it
            this.multiSelected.splice(index, 1);
        } else {
            item.isSelected = true;
            // If the item is not present, add it
            this.multiSelected.push(item);
        }
        //this.selectedItemsEvent.emit(this.multiSelected);
        //console.log('selectItem.multiSelected', this.multiSelected);
    }
}
